import classNames from 'classnames';
import { FC } from 'react';

import { FileName, AudioPlayerTrackCaption, PlayIconType } from '@gem/ui-kit';

import { AudioState } from 'APP/main/components/AudioState/AudioState';

import styles from './SharedAudioPlayer.styles.m.css';

interface ISharedAudioPlayerProps {
  className?: string;
  messageId: string;
  groupId: string;
  payloadId: string;
  fileName: string;
  size: number;
  isPlaying: boolean;
  isActiveTrack: boolean;
  duration: number;
  progress: number;
  onTogglePlay(): void;
}

export const SharedAudioPlayer: FC<ISharedAudioPlayerProps> = (props) => {
  const {
    className,
    messageId,
    groupId,
    payloadId,
    fileName,
    size,
    isPlaying,
    isActiveTrack,
    duration,
    progress,
    onTogglePlay,
  } = props;

  return (
    <div className={classNames(styles.container, className)}>
      <AudioState
        className={styles.icon}
        groupId={groupId}
        messageId={messageId}
        payloadId={payloadId}
        iconType={isPlaying ? PlayIconType.Pause : PlayIconType.Play}
        onClick={onTogglePlay}
      />
      <div>
        <FileName
          className={styles.title}
          name={fileName}
        />
        <AudioPlayerTrackCaption
          isPlaying={isActiveTrack}
          duration={duration}
          progress={progress}
          size={size}
          delimiter={' ⋅'}
        />
      </div>
    </div>
  );
};
